<template>
    <div class="slhSignIn">
        <el-form label-position="top" class="slhSignInForm" :rules="rules" ref="ruleForm" label-width="80px" :model="ruleForm">
            <p class="title">注册</p>
            <el-form-item label="企业名称：" prop="companyName">
              <el-input v-model="ruleForm.companyName" :maxlength="25" placeholder="请填写完整的家政企业名称"></el-input>
            </el-form-item>
            <el-form-item label="企业地址：" prop="address">
              <div class="cityBox">
                  <!-- <el-select v-model="ruleForm.city" :disabled="true" placeholder="请选择省">
                    <el-option :label="city.name" :value="city.code" v-for="city in cityList" :key="city.code"></el-option>
                  </el-select> -->
                  <el-input v-model="ruleForm.city" :disabled="true" class="city"></el-input>
                  <el-select v-model="ruleForm.regionCode" placeholder="请选择区">
                    <el-option :label="item.name" :value="item.code" v-for="item in areaList" :key="item.code"></el-option>
                  </el-select>
              </div>
              <el-input v-model="ruleForm.address" :maxlength="30" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="管理员姓名：" prop="userName">
              <el-input v-model="ruleForm.userName" :maxlength="15" placeholder="请输入管理员姓名"></el-input>
            </el-form-item>
            <!-- <el-form-item label="密码：" prop="name">
              <el-input v-model="ruleForm.password" placeholder="请输入6-16位密码"></el-input>
            </el-form-item> -->
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="请输入11位手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="authCode" ref="authCode" class="mt32 input_auth_btn">
              <el-input placeholder="请输入验证码" v-model="ruleForm.authCode" @keyup.enter.native="onSubmit">
							</el-input>
							<div  class="count_down"
										@click="postAccountGetAuthCode"
										:class="{active_btn: 0 < Countdown.time}">
									{{ 0 >= Countdown.time ? '获取验证码' : countTimer }}
							</div>
            </el-form-item>
            <el-form-item>
							<el-button type="primary" class="signIn-btn" @click="onSubmit">注册</el-button>
						</el-form-item>
            <div class="bottom">
                <span class="line"></span>
                <span class="text">已有账号? </span>
                <router-link :to="{ name: 'login', query: { account: this.ruleForm.phone } }">立即登录</router-link>
                <span class="line line2"></span>
                
            </div>
        </el-form>

    </div>
</template>

<script>
import { phoneNumberValidator, passwordValidator, isPhone } from '@/util/validate';
export default {
    name:'slhSignIn',
    computed:{
      countTimer() {
        return  this.Countdown.time+'s后重新获取'
      },
    },
    data(){
        return {
            cityList:[],
            areaList:[],
            ruleForm: {
              companyName: '',
              userName:'',
              regionCode: '',
              authCode:'',
              phone:'',
              address:'',
              city:'上海市'
            },
            Countdown: {
              time: 0,
            },
            rules:{
                companyName:[
                  { required: true, message: '请填写完整的家政企业名称', trigger: 'blur' },
                ],
                userName:[
                  { required: true, message: '请输入管理员姓名', trigger: 'blur' },
                ],
                address:[
                  { required: true, message: '请输入企业地址', trigger: 'blur' },
                ],
                authCode: [
                  { required: true, message: '请输入验证码', trigger: 'blur' },
                  { min: 6, max: 6, message: '请输入六位验证码', trigger: 'blur' }
                ],
                phone:[
                  {
                    required: true,
                    message: '请输入手机号',
                    trigger: 'blur',
                  },
                  {
                    validator: phoneNumberValidator,
                    trigger: 'blur',
                    message: '请输入正确的手机号',
                  }
                ]
            }
        }
    },
    created(){ 
        this.getCityTree();
    },
    methods:{
        // 获取省市区
        getCityTree(){
            this.$api.center.getTree().then(res => {
                 res.data.forEach(item => {
                    if(item.code === '31'){
                        this.cityList = item.children;
                    }
                })
                this.cityList.filter(item => {
                    if(item.code === '3101'){
                        this.areaList = item.children;
                    }
                })
            })
        },
        postAccountGetAuthCode() {
          const data = {
            phone: this.ruleForm.phone,
            type: 1,
            adminFlag: 1,
          }
          if (isPhone.test(data.phone)) {
            if (this.Countdown.time > 0) return
            this.Countdown.time = 60
            this.setCountdown()
            this.$api.operate.postAccountGetAuthCode({ data })
          }
        },
        setCountdown() {
          let Countdown = null
          Countdown = setInterval(() => {
            this.Countdown.time--
            if (this.Countdown.time <= 0) {
              clearInterval(Countdown)
            }
          }, 1000)
        },
        async onSubmit() {
            this.$refs.ruleForm.validate((valid) => {
              if (valid) {
                  this.saveCompany()
              } else {
                return false
              }
            })
            
        },
        saveCompany(){
            const data = {
                ...this.ruleForm
            }
            this.$api.shanglianhui.saveCompany({data}).then(res => {
                if(res.data){
                    this.$message.success('注册成功');
                    this.$router.push('/entrance/login')
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .slhSignIn{
        padding: 80px 0 ;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }
    .slhSignIn .title{
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 34px;
        margin-bottom: 32px;
    }
    .slhSignInForm{
        width: 560px;
        max-height:100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin: 0 auto;
        text-align: left;
        padding: 40px 80px;
        overflow-y: scroll;
        box-sizing: border-box;
        /deep/.el-form-item{
            margin-bottom: 32px;
            .el-form-item__label{
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 22px;
                padding-bottom: 8px;
            }
            .cityBox{
                display: flex;
                margin-bottom: 8px;
                .el-input{
                    width: 196px;
                }
                .el-select{
                    margin-left: 8px;
                }
            }
            .el-button--primary{
                background: #1972ff !important;
                border-color: #1972ff !important;
            }
        }
        .signIn-btn{
            width: 100%;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
        .bottom{
            display: flex;
            align-items: center;
            text-align: center;
            .line{
                display: inline-block;
                width: 90px;
                height: 1px;
                background: #D8D8D8;
                border-radius: 1px;
                margin-left: 11px;
                margin-right: 16px;
                &.line2{
                    margin-left: 16px;
                    margin-right: 0;
                }
            }
            .text{
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #737386;
                line-height: 22px;
            }
            a{
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1972FF;
              line-height: 22px;
            }
        }
        .input_auth_btn{
            position: relative;
            border-radius: 4px;
            .count_down{
                position: absolute;
                width: 112px;
                height: 24px;
                top: 8px;
                line-height: 24px;
                right: 0;
                cursor: pointer;
                border-left: 1px solid #d3d3e1;
                color: #1972ff;
                text-align: center;
                &.active_btn{
                    color: #999;
                }
            }
        }
    }
</style>